var _path, _path2, _polygon, _polygon2, _path3, _polygon3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-115"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.71,436.26c.45-3.24-4.12-5.9-7.56-6.18-1.64-.13-3.34.12-4.89-.42-3.37-1.18-4.71-5.52-8-6.91-2.46-1-5.28-.11-7.66,1.09s-4.73,2.7-7.39,2.87c-2.31.15-4.82-.71-6.84.42-1.51.84-2.3,2.58-3.69,3.6a8.72,8.72,0,0,1-4.82,1.31,13.65,13.65,0,0,0-5,.81c-1.53.71-2.8,2.33-2.48,4Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660,149.87c.73-5.33-6.79-9.71-12.45-10.17-2.69-.22-5.49.19-8-.7-5.53-1.92-7.74-9.07-13.14-11.35-4-1.7-8.69-.19-12.6,1.78s-7.78,4.45-12.16,4.73c-3.8.24-7.93-1.17-11.26.69-2.48,1.38-3.78,4.24-6.06,5.93s-5.15,2-7.93,2.15-5.65.18-8.17,1.33-4.62,3.83-4.09,6.56Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.5,283.22l24.12-3.69a24.41,24.41,0,1,1-27.81-20.43,24.2,24.2,0,0,1,6.36-.13Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.32,259l-2.93,18.7,18.36-3.44S126.05,263.82,113.32,259Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.48,355.13a23.76,23.76,0,0,1,6.25,1l4.07-4.22,8.3,5-1.86,5.57a23.44,23.44,0,0,1,3.74,5.1l5.87-.11,2.3,9.43-5.24,2.62a23.76,23.76,0,0,1-1,6.25l4.22,4.07-5,8.3-5.57-1.86a23.44,23.44,0,0,1-5.1,3.74l.11,5.86-9.43,2.31-2.62-5.24a23.76,23.76,0,0,1-6.25-1l-4.07,4.22-8.3-5,1.86-5.56a23.68,23.68,0,0,1-3.74-5.1l-5.86.11-2.31-9.43,5.24-2.62a23.76,23.76,0,0,1,1-6.25l-4.22-4.07,5-8.3,5.56,1.86a23.68,23.68,0,0,1,5.1-3.74l-.11-5.86,9.43-2.31,2.62,5.24ZM562,368.82a10.41,10.41,0,1,0,12.58,7.63A10.42,10.42,0,0,0,562,368.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562,368.82a7.74,7.74,0,0,1,2.54-.4,10.27,10.27,0,0,1,6.6,2.26,10.38,10.38,0,0,1,3,3.85,10.72,10.72,0,0,1,.92,5.55,9.93,9.93,0,0,1-.76,3,10,10,0,0,1-1.66,2.74,10.63,10.63,0,0,1-12.29,3,10.75,10.75,0,0,1-4.79-4,10.67,10.67,0,0,1-1.75-5.34,10.53,10.53,0,0,1,5.71-9.87,7.73,7.73,0,0,1,2.45-.82,24.9,24.9,0,0,0-2.34,1,10.38,10.38,0,0,0-4.53,5,10.1,10.1,0,0,0-.8,4.61,10.25,10.25,0,0,0,1.72,5.07,10.35,10.35,0,0,0,4.56,3.72,10.09,10.09,0,0,0,11.61-2.85,9.39,9.39,0,0,0,1.58-2.59,9.51,9.51,0,0,0,.74-2.81,10.17,10.17,0,0,0-3.66-9,10.36,10.36,0,0,0-6.34-2.36A24.14,24.14,0,0,0,562,368.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.17,387.3a8.56,8.56,0,0,1-.22-1.93,16.66,16.66,0,0,0-.26-2.33,22.64,22.64,0,0,0-.61-3.12,29.26,29.26,0,0,0-3.24-8,30.16,30.16,0,0,0-7.47-8.6A29.47,29.47,0,0,0,308,357.51a29.84,29.84,0,0,0-15.61,1,27.8,27.8,0,0,0-7.59,3.87,27.37,27.37,0,0,0-6.4,6.14,29.5,29.5,0,0,0-.85,35,35.69,35.69,0,0,0,2.81,3.51,34.93,34.93,0,0,0,3.29,2.94,27.76,27.76,0,0,0,7.39,4.23,30,30,0,0,0,36.11-11.68,29,29,0,0,0,3.62-7.86,21.11,21.11,0,0,0,.76-3.08,14.47,14.47,0,0,0,.37-2.31,8.2,8.2,0,0,1,.32-1.92,9.35,9.35,0,0,1,0,1.95,13.06,13.06,0,0,1-.22,2.36,20.53,20.53,0,0,1-.62,3.18,28.61,28.61,0,0,1-3.46,8.18,30.8,30.8,0,0,1-21.13,14.28,31.08,31.08,0,0,1-16.33-1.66,29.17,29.17,0,0,1-7.81-4.41,34.81,34.81,0,0,1-3.48-3.09,34.44,34.44,0,0,1-3-3.68,31,31,0,0,1,.9-36.92,36.67,36.67,0,0,1,3.15-3.54,35.85,35.85,0,0,1,3.63-2.91,29.24,29.24,0,0,1,8-4,31.07,31.07,0,0,1,16.39-.87,30.86,30.86,0,0,1,20.41,15.29,28.32,28.32,0,0,1,3.06,8.34,20.4,20.4,0,0,1,.47,3.21,12.52,12.52,0,0,1,.1,2.36A9.5,9.5,0,0,1,332.17,387.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.08,368.3c.07.09-.48.57-1.54,1.36l-2,1.4c-.38.27-.79.57-1.24.85l-1.5.78A34.35,34.35,0,0,1,302,377.2l-2.71-.12-2.6-.41c-.42-.07-.84-.13-1.26-.21l-1.21-.33c-.8-.22-1.59-.41-2.34-.65a38.91,38.91,0,0,1-7.59-3.49c-4.07-2.47-6.06-4.71-5.9-4.85s2.38,1.69,6.48,3.82A46.11,46.11,0,0,0,292.3,374c.73.22,1.49.38,2.26.57l1.16.29,1.21.18,2.49.37,2.58.1a37,37,0,0,0,17.31-3.88l1.52-.66c.46-.24.88-.5,1.28-.73l2.08-1.14C325.34,368.5,326,368.2,326.08,368.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.42,405.28c-.07-.1.48-.57,1.54-1.36l2-1.4c.39-.27.79-.57,1.25-.85l1.49-.79a34.37,34.37,0,0,1,17.89-4.5l2.7.12,2.6.41c.42.07.85.13,1.26.21l1.22.32c.79.22,1.58.41,2.33.65a38.93,38.93,0,0,1,7.59,3.5c4.08,2.46,6.06,4.7,5.91,4.85s-2.38-1.69-6.49-3.82a45.19,45.19,0,0,0-7.47-3.06c-.73-.21-1.49-.37-2.25-.57l-1.17-.29-1.21-.18-2.48-.36-2.58-.11a37.1,37.1,0,0,0-17.32,3.89l-1.51.66c-.46.24-.88.5-1.29.72l-2.07,1.14C278.16,405.08,277.49,405.37,277.42,405.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.15,388c0,.46-13.64.5-30.43.09s-30.4-1.11-30.39-1.57,13.63-.51,30.43-.1S332.16,387.55,332.15,388Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.34,416.94c-.46,0-.51-13.63-.1-30.42s1.11-30.39,1.57-30.38.51,13.63.1,30.43S300.8,417,300.34,416.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.34,416.9c-.12.17-3.47-2.1-7.33-7.24a40.87,40.87,0,0,1-5.44-9.87,36.52,36.52,0,0,1-2.35-13.63,34.68,34.68,0,0,1,3.07-13.49,42.12,42.12,0,0,1,5.94-9.57c4.09-5,7.47-7.14,7.59-7s-2.9,2.68-6.66,7.69a45.65,45.65,0,0,0-5.46,9.45,35,35,0,0,0-2.81,12.91A37,37,0,0,0,289,399.26a43.64,43.64,0,0,0,5,9.71C297.49,414.16,300.51,416.71,300.34,416.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.5,356.15c.11-.17,3.46,2.1,7.33,7.24a40.87,40.87,0,0,1,5.43,9.87,36.52,36.52,0,0,1,2.36,13.63,35,35,0,0,1-3.07,13.49,42.83,42.83,0,0,1-5.94,9.57c-4.1,4.95-7.48,7.14-7.59,7s2.9-2.68,6.66-7.69a45.64,45.64,0,0,0,5.45-9.45A35,35,0,0,0,316,386.86a37.26,37.26,0,0,0-2.13-13.07,43.22,43.22,0,0,0-5-9.71C305.34,358.89,302.33,356.34,302.5,356.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.5,
    y: 215.02,
    width: 50.87,
    height: 34.29,
    transform: "translate(-19.62 21.7) rotate(-5.08)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.75,212.84a3.64,3.64,0,0,1-.44.49c-.32.35-.76.8-1.3,1.36-1.18,1.21-2.82,2.89-4.85,4.95L236,235.9l-.13.13-.16-.11-.38-.25L216,222.79l-5.83-3.95-1.57-1.1a3.54,3.54,0,0,1-.53-.4,2.88,2.88,0,0,1,.58.33l1.62,1,5.91,3.82,19.4,12.78.38.25-.29,0,16.25-16.16,5-4.84,1.36-1.3C258.56,213,258.73,212.82,258.75,212.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.11,251.49c-.1-.08,3.29-5.1,7.58-11.21s7.86-11,8-10.95-3.29,5.09-7.58,11.21S211.22,251.56,211.11,251.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.46,227.41c.09-.09,4.27,4.22,9.33,9.63s9.08,9.86,9,10-4.27-4.23-9.33-9.64S243.36,227.49,243.46,227.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.47,143.73c1.12-8.14-10.38-14.85-19-15.54-4.12-.34-8.4.29-12.3-1.07-8.46-2.94-11.84-13.87-20.09-17.35-6.17-2.6-13.28-.29-19.26,2.72s-11.89,6.8-18.57,7.23c-5.82.37-12.13-1.78-17.21,1.06-3.79,2.11-5.78,6.48-9.27,9.05s-7.88,3.06-12.12,3.29-8.63.27-12.49,2-7,5.85-6.25,10Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.6,451.57c.71-5.11-6.5-9.31-11.92-9.75-2.58-.2-5.26.19-7.71-.66-5.3-1.85-7.42-8.7-12.59-10.88-3.87-1.63-8.32-.18-12.07,1.71s-7.45,4.26-11.64,4.53c-3.65.23-7.6-1.12-10.79.66-2.38,1.32-3.62,4.06-5.81,5.68s-4.94,1.91-7.59,2.06-5.41.17-7.83,1.27-4.42,3.67-3.92,6.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.25,103.54c.73-5.34-6.79-9.72-12.45-10.18-2.69-.21-5.49.2-8.05-.69-5.53-1.93-7.74-9.08-13.14-11.36-4-1.7-8.69-.19-12.6,1.78s-7.78,4.45-12.15,4.73c-3.81.25-7.94-1.16-11.27.69-2.48,1.39-3.77,4.25-6.06,5.93s-5.15,2-7.93,2.15-5.64.18-8.17,1.34-4.62,3.82-4.09,6.55Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sheet--inject-115"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.41,239.59l-32.27,17a4.58,4.58,0,0,1-6.17-1.92L324.48,210a4.56,4.56,0,0,1,1.91-6.16l20.47-10.76,24.44,8,17,32.38A4.56,4.56,0,0,1,386.41,239.59Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.86,193.05l6.62,12.57a4.24,4.24,0,0,0,5.73,1.78l12.09-6.35Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M354.22,206.64a4.72,4.72,0,0,0,5.44,2.31l.45-.12c1.73-.55,13.09-4.17,13-4.4s-1.77-3.38-1.77-3.38l-12.09,6.35S356.14,208.89,354.22,206.64Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.86,193.05l6.62,12.57a4.24,4.24,0,0,0,5.73,1.78l12.09-6.35Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M350.5,206.53c.08.16-3.19,2.05-7.31,4.22s-7.54,3.8-7.62,3.63,3.19-2,7.31-4.22S350.41,206.37,350.5,206.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.88,208.57c.09.16-5.35,3.18-12.13,6.75s-12.36,6.33-12.44,6.17,5.34-3.18,12.13-6.75S363.8,208.41,363.88,208.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.22,213.34c.08.16-5.85,3.45-13.24,7.34s-13.47,6.91-13.55,6.75,5.84-3.45,13.24-7.34S369.13,213.18,369.22,213.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.16,218.94c.09.16-5.84,3.45-13.24,7.34s-13.46,6.91-13.55,6.75,5.85-3.45,13.24-7.34S372.08,218.78,372.16,218.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.11,224.54c.08.16-5.85,3.45-13.24,7.34s-13.47,6.91-13.55,6.75,5.84-3.44,13.24-7.34S375,224.38,375.11,224.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.05,230.14c.09.17-5.84,3.45-13.24,7.34s-13.46,6.91-13.55,6.75,5.85-3.44,13.25-7.34S378,230,378.05,230.14Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stopwatch--inject-115"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 263.82,
    y: 274.53,
    width: 3.27,
    height: 5.1,
    transform: "translate(-101.23 390.13) rotate(-63.36)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.05,273.59l-3,6-4.91-2.46a12.87,12.87,0,0,1,3-6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.54,278.6a10.3,10.3,0,0,1-2.65-1.09,10.74,10.74,0,0,1-2.49-1.45,11.2,11.2,0,0,1,2.66,1.1A10.86,10.86,0,0,1,263.54,278.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.11,277.46a11.69,11.69,0,0,1-2.67-1.21,15.13,15.13,0,0,1-2.52-1.51,9.46,9.46,0,0,1,2.7,1.16A10.37,10.37,0,0,1,264.11,277.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.88,275.93a11.38,11.38,0,0,1-2.7-1.23,13.88,13.88,0,0,1-2.53-1.55,9.61,9.61,0,0,1,2.71,1.2A11.58,11.58,0,0,1,264.88,275.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.57,274.51a10.22,10.22,0,0,1-2.65-1.12,11.13,11.13,0,0,1-2.48-1.47,10.22,10.22,0,0,1,2.65,1.12A11.13,11.13,0,0,1,265.57,274.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.4,
    y: 259.42,
    width: 3.27,
    height: 5.1,
    transform: "translate(130.43 -99.51) rotate(23.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.55,262.38l-6.16-2.69,2.2-5a12.72,12.72,0,0,1,6.16,2.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.42,260.14a10.79,10.79,0,0,1,.95-2.71,10.94,10.94,0,0,1,1.31-2.55,10.46,10.46,0,0,1-.95,2.71A10.94,10.94,0,0,1,301.42,260.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.59,260.65a11.5,11.5,0,0,1,1.07-2.73,15,15,0,0,1,1.37-2.6,9,9,0,0,1-1,2.76A10.56,10.56,0,0,1,302.59,260.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.16,261.34a11.21,11.21,0,0,1,1.09-2.76,13.8,13.8,0,0,1,1.41-2.61,9.62,9.62,0,0,1-1.06,2.77A12.13,12.13,0,0,1,304.16,261.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.61,262a21.07,21.07,0,0,1,2.32-5.26,10.55,10.55,0,0,1-1,2.71A10.77,10.77,0,0,1,305.61,262Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.43,
    y: 258.42,
    width: 3.87,
    height: 6.04,
    transform: "translate(-79.02 128.62) rotate(-22.67)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.59,258.77l-7.35,3.07-2.51-6a15.16,15.16,0,0,1,7.36-3.07Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.18,252.76a8.64,8.64,0,0,1-7.46,3.15,19.48,19.48,0,0,0,4-1A20.39,20.39,0,0,0,282.18,252.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.66,260.81a10.16,10.16,0,0,1-1.25-2.5,10,10,0,0,1-.9-2.65,10.38,10.38,0,0,1,1.26,2.5A10.15,10.15,0,0,1,279.66,260.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.08,260.26a9.93,9.93,0,0,1-1.26-2.51,10.09,10.09,0,0,1-.9-2.66,10.33,10.33,0,0,1,1.26,2.51A10.55,10.55,0,0,1,281.08,260.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.47,259.65a9.93,9.93,0,0,1-1.26-2.51,10.09,10.09,0,0,1-.9-2.66,10.33,10.33,0,0,1,1.26,2.51A10.55,10.55,0,0,1,282.47,259.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.63,259.17a12.24,12.24,0,0,1-1.35-2.72,12,12,0,0,1-1-2.87,11.46,11.46,0,0,1,1.34,2.72A11.67,11.67,0,0,1,283.63,259.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.33,261.34a12.24,12.24,0,0,1-1.35-2.72,12,12,0,0,1-1-2.87,24.18,24.18,0,0,1,2.33,5.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.22,
    cy: 288.65,
    r: 28.14,
    transform: "translate(-109.84 372.65) rotate(-56.45)",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.13,
    cy: 288.44,
    r: 23.63,
    transform: "translate(-84.32 452.22) rotate(-68.15)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.94,279.33a3.58,3.58,0,0,1-.18-.34l-.5-1-.37-.74c-.14-.27-.33-.55-.52-.86a18.19,18.19,0,0,0-1.39-2.05,22.59,22.59,0,0,0-4.84-4.77,23.5,23.5,0,0,0-8.09-3.84,22.87,22.87,0,0,0-13.67.59c-.48.18-1,.33-1.44.54l-1.4.67c-.23.12-.48.22-.7.35l-.68.41c-.45.28-.91.55-1.36.85a27,27,0,0,0-2.53,2.05,25.15,25.15,0,0,0-2.3,2.42c-.36.44-.67.91-1,1.37a11.42,11.42,0,0,0-.93,1.44,27.69,27.69,0,0,0-1.59,3.12,26.76,26.76,0,0,0-1.07,3.39,22.77,22.77,0,0,0-.6,7.25,24.92,24.92,0,0,0,1.73,7.29,25.21,25.21,0,0,0,4,6.36,22.75,22.75,0,0,0,5.58,4.67,26.29,26.29,0,0,0,3.17,1.62,25.63,25.63,0,0,0,3.32,1.07,12.37,12.37,0,0,0,1.69.35c.56.08,1.12.19,1.68.24a24.94,24.94,0,0,0,3.34.07,24.51,24.51,0,0,0,3.24-.36c.53-.1,1-.25,1.56-.37l.76-.19c.26-.07.5-.17.75-.26l1.46-.52c.48-.19.93-.43,1.39-.64a21.93,21.93,0,0,0,2.61-1.46,23.63,23.63,0,0,0,10.38-16.31,22.27,22.27,0,0,0,0-6.79,16.73,16.73,0,0,0-.48-2.44c-.09-.35-.16-.67-.24-1l-.27-.78-.37-1.06c-.08-.24-.11-.37-.11-.37s.06.12.15.35l.4,1.06c.09.23.18.49.29.78s.17.61.26,1a17.94,17.94,0,0,1,.52,2.45,22.34,22.34,0,0,1,.06,6.84,23.8,23.8,0,0,1-10.42,16.55,24.26,24.26,0,0,1-2.64,1.49c-.47.21-.93.46-1.41.65l-1.48.54c-.25.08-.5.19-.76.26l-.78.19c-.52.13-1,.28-1.57.38a25.48,25.48,0,0,1-3.29.38,25.82,25.82,0,0,1-3.4-.06c-.56-.06-1.13-.16-1.71-.24a12.54,12.54,0,0,1-1.7-.36,22.07,22.07,0,0,1-6.61-2.72,23,23,0,0,1-5.67-4.74,23.56,23.56,0,0,1-5.8-13.88,23.23,23.23,0,0,1,.62-7.37,22.07,22.07,0,0,1,2.71-6.61,11.71,11.71,0,0,1,.94-1.46c.35-.47.67-.95,1-1.39a26.65,26.65,0,0,1,4.92-4.53c.45-.31.93-.57,1.38-.86l.69-.41c.23-.14.48-.24.71-.36l1.43-.67c.48-.21,1-.36,1.45-.54a21.31,21.31,0,0,1,2.92-.83,23.77,23.77,0,0,1,19.09,4.21,22.47,22.47,0,0,1,4.83,4.86,16.08,16.08,0,0,1,1.37,2.09c.18.31.37.59.51.86l.35.75c.2.44.35.78.47,1S313.94,279.33,313.94,279.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.62,280.32a13.85,13.85,0,0,1-3.71,1.3,13.57,13.57,0,0,1,3.39-2c1.94-.95,3.59-1.53,3.7-1.3S312.59,279.46,310.62,280.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,295.66a13.3,13.3,0,0,1-3.54-1.68,13.6,13.6,0,0,1,3.8,1c2,.69,3.63,1.44,3.54,1.68S313,296.44,311,295.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.46,306.83a13.2,13.2,0,0,1-1.34-3.68,12.93,12.93,0,0,1,2,3.36c1,1.92,1.57,3.58,1.34,3.69S301.34,308.8,300.46,306.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.12,307.37a13.19,13.19,0,0,1,1.64-3.56,13.83,13.83,0,0,1-.93,3.81c-.67,2-1.41,3.64-1.65,3.56S284.36,309.39,285.12,307.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.84,297a13,13,0,0,1,3.67-1.37,13.73,13.73,0,0,1-3.35,2.05c-1.91,1-3.56,1.6-3.67,1.38S271.88,297.87,273.84,297Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.13,281.63a13.66,13.66,0,0,1,3.58,1.61,13.54,13.54,0,0,1-3.82-.9c-2.06-.64-3.66-1.36-3.58-1.6S271.1,280.9,273.13,281.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.41,270.24a13.2,13.2,0,0,1,1.41,3.65,13.4,13.4,0,0,1-2.08-3.32c-1-1.9-1.64-3.54-1.42-3.65S282.48,268.29,283.41,270.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.73,269.36a13.55,13.55,0,0,1-1.56,3.6,13.21,13.21,0,0,1,.85-3.83c.62-2.06,1.32-3.67,1.56-3.6S299.44,267.33,298.73,269.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.24,279.51A13.61,13.61,0,0,1,306.6,281a13.6,13.6,0,0,1,3.3-2.12c1.89-1,3.52-1.68,3.64-1.46S312.18,278.57,310.24,279.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.81,268.38a9.67,9.67,0,0,1-.92,1,29.6,29.6,0,0,0-2.35,2.79,27.21,27.21,0,0,0-4.7,22.75,28.8,28.8,0,0,0,1.05,3.49,11,11,0,0,1,.45,1.26,1.2,1.2,0,0,1-.17-.3c-.1-.21-.26-.5-.42-.91a23.05,23.05,0,0,1-1.18-3.47,26.5,26.5,0,0,1,4.75-23,24.84,24.84,0,0,1,2.47-2.73c.3-.3.57-.51.74-.66S273.8,268.37,273.81,268.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.47,264a13.05,13.05,0,0,1-2.37,1.49,12.45,12.45,0,0,1-2.48,1.31,8.5,8.5,0,0,1,2.28-1.65A8.23,8.23,0,0,1,280.47,264Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M280.18,308.83s18.75,13.11,32.47-3.34c14.31-17.18-4.92-34.82-4.92-34.82s15.88,13.83,2.78,32.63c-3.26,4.69-8.09,6.71-11.94,7.88C288.75,314.18,280.18,308.83,280.18,308.83Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M293.37,274.31a80.27,80.27,0,0,1,3.72,9.71,13.29,13.29,0,0,1,.73,3.67,4.87,4.87,0,0,1-1.23,3.46,3,3,0,0,1-3.44.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.94 286.92 293.29 270.26 294.8 287.33 292.66 289.08 290.94 286.92",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "293.29 270.26 293.11 286.35 294.8 287.33 293.29 270.26"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M295.21,288a2.76,2.76,0,1,1-3.61-1.48A2.76,2.76,0,0,1,295.21,288Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.21,288s-.12-.21-.4-.54a2.67,2.67,0,0,0-1.48-.93,2.6,2.6,0,1,0-.54,5.12,2.64,2.64,0,0,0,2.14-1.27,2.72,2.72,0,0,0,.39-1.71c-.05-.43-.14-.66-.11-.67a1.32,1.32,0,0,1,.26.65,2.77,2.77,0,0,1-.3,1.87A2.88,2.88,0,0,1,292.8,292a2.94,2.94,0,0,1-2.13-5.11,2.91,2.91,0,0,1,2.73-.64,2.79,2.79,0,0,1,1.54,1.11A1.35,1.35,0,0,1,295.21,288Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.56,288.28a2.06,2.06,0,1,1-2.69-1.1A2.06,2.06,0,0,1,294.56,288.28Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Video--inject-115"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.5,358.2a2.81,2.81,0,0,0,1.24-.83,2.64,2.64,0,0,0,.61-1.67,4.15,4.15,0,0,0-.2-1.15c-.1-.41-.21-.85-.33-1.31-.92-3.73-2.25-9.09-3.89-15.69q-.6-2.49-1.28-5.21c-.22-.9-.44-1.83-.67-2.77a8,8,0,0,0-.4-1.36,2.46,2.46,0,0,0-.91-1,2.27,2.27,0,0,0-1.33-.32,13.56,13.56,0,0,0-1.46.33l-3.06.8-6.38,1.65L209,337a2.4,2.4,0,0,0-1.71,2.71c.3,1.25.6,2.48.89,3.71q.9,3.7,1.76,7.28c1.16,4.78,2.27,9.38,3.33,13.77l.39,1.64a2.62,2.62,0,0,0,.71,1.33,2.35,2.35,0,0,0,1.33.62,4,4,0,0,0,1.5-.22l6-1.55,10.82-2.75,15.68-4,4.27-1,1.11-.26.38-.08-.37.13-1.1.3-4.24,1.15-15.64,4.11-10.81,2.82-6,1.56a4.45,4.45,0,0,1-1.66.25,2.75,2.75,0,0,1-1.59-.75,3,3,0,0,1-.84-1.55c-.13-.54-.27-1.08-.4-1.63l-3.35-13.76-1.77-7.28q-.45-1.86-.9-3.75a2.88,2.88,0,0,1,2.07-3.27l28.44-7.31,6.39-1.64,3.06-.78a10.34,10.34,0,0,1,1.55-.34,2.69,2.69,0,0,1,1.57.39A2.87,2.87,0,0,1,251,328a8,8,0,0,1,.41,1.45c.23.94.45,1.87.67,2.77q.65,2.72,1.25,5.21c1.57,6.63,2.84,12,3.73,15.73.11.47.21.91.31,1.32a4.65,4.65,0,0,1,.18,1.19,2.8,2.8,0,0,1-.68,1.74,2.61,2.61,0,0,1-.94.66A1.52,1.52,0,0,1,255.5,358.2Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.18 344.4 239.28 346.24 234.71 350.79 230.14 355.33 228.61 348.94 227.09 342.56 233.18 344.4",
    style: {
      fill: "#6C5DD3"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Photos--inject-115"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.56,
    y: 300.86,
    width: 33.04,
    height: 26.41,
    transform: "matrix(0.97, -0.25, 0.25, 0.97, -73.92, 50.7)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.74,297.13l-.16,0-.44.13-1.74.46-6.54,1.72-23.07,6,.06-.1c2,7.6,4.26,16.32,6.66,25.55h0l-.12-.06,32-8.31-.06.1c-2-7.7-3.63-14.09-4.78-18.55-.58-2.23-1-4-1.33-5.19l-.35-1.37c-.08-.31-.11-.47-.11-.47l.12.45c.09.31.21.77.36,1.35l1.37,5.16c1.17,4.47,2.85,10.87,4.88,18.58l0,.07-.08,0-32,8.34-.09,0,0-.1h0l-6.65-25.56,0-.08.08,0,23.15-6,6.54-1.68,1.72-.44.44-.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.7,
    y: 302.53,
    width: 30.71,
    height: 23.09,
    transform: "translate(-73.92 50.69) rotate(-14.59)",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.1 329.11 155.87 312.52 164.56 319.54 167.72 313.76 178.83 321.38 149.1 329.11",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.59,308.44a2.42,2.42,0,1,1-3-1.73A2.43,2.43,0,0,1,164.59,308.44Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "149.1 329.11 155.87 312.52 164.56 319.54 167.72 313.76 178.83 321.38 149.1 329.11"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M164.59,308.44a2.42,2.42,0,1,1-3-1.73A2.43,2.43,0,0,1,164.59,308.44Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 276.73,
    width: 49.92,
    height: 39.91,
    transform: "translate(-20.4 13.67) rotate(-4.03)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.46,275l-.24,0-.7.05-2.71.21-10.19.75-36,2.6.12-.14c.84,11.85,1.8,25.44,2.82,39.81h0l-.15-.13,49.79-3.49-.11.13c-.82-12-1.5-21.93-2-28.88-.23-3.47-.41-6.2-.54-8.07-.06-.92-.1-1.64-.13-2.13s0-.74,0-.74l.06.72c0,.48.09,1.18.16,2.1.14,1.86.34,4.58.6,8,.51,7,1.23,16.93,2.1,28.94v.12h-.12l-49.79,3.54h-.15v-.15h0c-1-14.37-2-28-2.79-39.81v-.13h.13l36-2.47,10.16-.68,2.68-.18.69,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.72,
    y: 279.24,
    width: 46.41,
    height: 34.88,
    transform: "translate(-20.41 13.67) rotate(-4.03)",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.01 315.72 176.65 292.95 187.62 305.77 193.91 298.06 208.3 312.45 162.01 315.72",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.74,289.29a3.66,3.66,0,1,1-3.91-3.39A3.66,3.66,0,0,1,190.74,289.29Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "162.01 315.72 176.65 292.95 187.62 305.77 193.91 298.06 208.3 312.45 162.01 315.72"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M190.74,289.29a3.66,3.66,0,1,1-3.91-3.39A3.66,3.66,0,0,1,190.74,289.29Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--light-bulb--inject-115"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.3,336A14.81,14.81,0,1,0,96.12,355l1.11,3.57,12.39-3.86s-.54-2-1.07-3.82A14.82,14.82,0,0,0,112.3,336Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.13,356.06l0-.17c0-.13,0-.31-.1-.53-.08-.47-.21-1.15-.35-2s-.29-2-.39-3.25a21.15,21.15,0,0,1,.06-4.33,13.63,13.63,0,0,1,.5-2.48,2.68,2.68,0,0,1,.7-1.17,1.53,1.53,0,0,1,1.35-.37,1,1,0,0,1,.62.42,1,1,0,0,1,.17.74,2.08,2.08,0,0,1-.8,1.28,4.06,4.06,0,0,1-5.73-1,3,3,0,0,1-.59-1.6,1.32,1.32,0,0,1,1-1.38,1,1,0,0,1,.88.27,1.33,1.33,0,0,1,.38.84,2.91,2.91,0,0,1-.55,1.71,4.39,4.39,0,0,1-3,2,3.86,3.86,0,0,1-3.37-1.18,2.24,2.24,0,0,1-.63-1.68,1.15,1.15,0,0,1,.43-.82,1.09,1.09,0,0,1,.89-.19,1.37,1.37,0,0,1,.79.43,2.37,2.37,0,0,1,.47.75,4.06,4.06,0,0,1,.29,1.68,4.41,4.41,0,0,1-1.25,3,4.47,4.47,0,0,1-2.8,1.31,2.33,2.33,0,0,1-1.49-.27,1.16,1.16,0,0,1-.5-1.34,1,1,0,0,1,.54-.51,1.48,1.48,0,0,1,.72-.08,2.16,2.16,0,0,1,1.16.7c.6.66,1.11,1.31,1.62,1.94,2,2.49,3.56,4.59,4.6,6.05.52.73.92,1.3,1.18,1.69l.31.45.09.15a1.16,1.16,0,0,1-.11-.14l-.32-.44c-.28-.38-.68-.95-1.21-1.67-1.06-1.44-2.61-3.53-4.64-6-.51-.62-1-1.28-1.62-1.92a1.93,1.93,0,0,0-1.09-.65,1,1,0,0,0-1.09.5,1,1,0,0,0,.45,1.15,2.23,2.23,0,0,0,1.38.25,4.36,4.36,0,0,0,2.7-1.28,4.27,4.27,0,0,0,.92-4.49,1.62,1.62,0,0,0-1.13-1.07.9.9,0,0,0-.75.16,1,1,0,0,0-.36.69,2.07,2.07,0,0,0,.59,1.55,3.64,3.64,0,0,0,3.2,1.12,4.24,4.24,0,0,0,2.88-1.9,2.73,2.73,0,0,0,.52-1.6,1.15,1.15,0,0,0-.33-.72.76.76,0,0,0-.71-.23,1,1,0,0,0-.63.45,1.34,1.34,0,0,0-.21.76,3,3,0,0,0,.56,1.51,4,4,0,0,0,2.61,1.67,3.89,3.89,0,0,0,2.88-.67,1.94,1.94,0,0,0,.75-1.18.87.87,0,0,0-.67-1,1.37,1.37,0,0,0-1.23.33,2.67,2.67,0,0,0-.66,1.11,13.71,13.71,0,0,0-.51,2.45,22.57,22.57,0,0,0-.08,4.31c.09,1.26.24,2.35.36,3.24s.25,1.57.32,2l.08.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.38,357.32l-10.63,3.31a.84.84,0,0,1-1-.55h0a.82.82,0,0,1,.55-1l10.64-3.32a.82.82,0,0,1,1,.55h0A.83.83,0,0,1,109.38,357.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.6,358,99,361.33a.84.84,0,1,0,.5,1.6l1.17-.37L103.1,365a1.07,1.07,0,0,0,1.08.26l3.8-1.18a1.08,1.08,0,0,0,.74-.84l.59-3.41.79-.25a.83.83,0,1,0-.5-1.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.28,334.18a10.85,10.85,0,0,1,2.24-2.77,7.9,7.9,0,0,1,2-1.31c.52-.22.84-.26.9-.16s-.81.95-2,2.37a12.14,12.14,0,0,0-1.75,13.06c.74,1.67,1.47,2.61,1.27,2.8s-.39,0-.83-.39A8,8,0,0,1,86.58,346a10.78,10.78,0,0,1-1.45-3.25,11.75,11.75,0,0,1-.28-4.4",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95,329.49c-.9.27-1.77.27-2-.17-.12-.23,0-.53.23-.83a2.84,2.84,0,0,1,1.24-.74,2.77,2.77,0,0,1,1.44-.07c.38.1.62.3.66.54",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.6,363.58s-.31,0-.81,0a6.41,6.41,0,0,0-1.87.34,6.14,6.14,0,0,0-1.69.89c-.39.29-.61.51-.63.49a2.16,2.16,0,0,1,.55-.59,5.42,5.42,0,0,1,1.71-1,5.24,5.24,0,0,1,1.94-.29A2.34,2.34,0,0,1,108.6,363.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.34,359.89c0,.05-1.9.68-4.27,1.42s-4.31,1.3-4.32,1.25,1.89-.68,4.27-1.42S109.32,359.84,109.34,359.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.07,361.36a6.46,6.46,0,0,1-1,.43c-.63.24-1.52.56-2.51.88s-1.88.59-2.54.77a5.58,5.58,0,0,1-1.08.25,9.1,9.1,0,0,1,1-.37l2.53-.82,2.52-.83A6.31,6.31,0,0,1,109.07,361.36Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-115"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.89,269.67c-11-10.19-30.5-9-40.18,2.47-3.81,4.52-6.4,10.44-11.64,13.18-8,4.21-17.76-1.1-26.8-.33-10.6.9-19.3,11.66-18,22.21.59,4.76,2.85,9.83.61,14.07-2.85,5.41-11.1,5.63-14.57,10.66-3.13,4.55-.69,11.26,3.86,14.4s10.41,3.53,15.93,3.28,11.12-1,16.5.2c5.93,1.34,11,5,16.69,7.24,13.57,5.44,29.46,2.41,42-5.06s22.3-18.89,30.78-30.8",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.89,269.67c-11-10.19-30.5-9-40.18,2.47-3.81,4.52-6.4,10.44-11.64,13.18-8,4.21-17.76-1.1-26.8-.33-10.6.9-19.3,11.66-18,22.21.59,4.76,2.85,9.83.61,14.07-2.85,5.41-11.1,5.63-14.57,10.66-3.13,4.55-.69,11.26,3.86,14.4s10.41,3.53,15.93,3.28,11.12-1,16.5.2c5.93,1.34,11,5,16.69,7.24,13.57,5.44,29.46,2.41,42-5.06s22.3-18.89,30.78-30.8",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M425.22,283.55c-9-8.78-25.59-7.55-33.15,2.46-4.61,6.11-7.26,15.45-14.85,16.47-5.14.7-10-3.17-15.19-2.77-6.9.52-11.07,8.93-9.3,15.61s7.65,11.49,13.82,14.63c21.37,10.85,49.85,5.11,65.36-13.17",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "628.94 305.9 617.37 289.5 632.42 278.83 642.96 300.24 629.63 305.76",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.33,297.31l8.19,14.77s17.76-3.36,19.54-.78L642,328.2l-13.7-22.49Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M641.1,316.09a1.34,1.34,0,0,0,0,1.79,1.3,1.3,0,0,0,1.77,0,1.42,1.42,0,0,0,0-1.9,1.34,1.34,0,0,0-1.84.19",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M642,328.2l-1.29-2.32,27.39-15.33s1.58-.21,2,.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M650.89,311.66c.07.14-.57.62-1,1.46s-.43,1.64-.58,1.67-.44-.9.08-1.91S650.84,311.52,650.89,311.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.56,311.11c.11.11-.34.7-.46,1.56s.12,1.56,0,1.63-.69-.64-.53-1.71S654.48,311,654.56,311.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.36,313.63c-.11.1-.71-.47-.81-1.43s.36-1.65.48-1.57,0,.72.07,1.51S658.48,313.53,658.36,313.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.65,308.5c0,.16-.73.35-1.47.87s-1.2,1.13-1.34,1.05.14-.91,1-1.51S648.65,308.36,648.65,308.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.94,305.55c0,.06-.46.47-1.41.84a7.14,7.14,0,0,1-2.81.49,1.79,1.79,0,0,1-.62-.07.68.68,0,0,1-.5-.69.88.88,0,0,1,.41-.68,1.94,1.94,0,0,1,.57-.24,6,6,0,0,1,1-.23,5.84,5.84,0,0,1,1.81.07c1,.21,1.55.59,1.52.65s-.61-.16-1.58-.26a6.47,6.47,0,0,0-1.68.05,5.75,5.75,0,0,0-1,.24c-.35.1-.6.25-.6.43s0,.09.13.14a1.89,1.89,0,0,0,.46,0c.34,0,.68,0,1,0a9.8,9.8,0,0,0,1.68-.3A13.35,13.35,0,0,1,646.94,305.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.88,305.86c0,.05-.6-.28-1.19-1.14a5.16,5.16,0,0,1-.73-1.65,5.1,5.1,0,0,1-.16-1.07,1.37,1.37,0,0,1,.47-1.25.75.75,0,0,1,.82,0,1.92,1.92,0,0,1,.46.43,3.69,3.69,0,0,1,.57.94,3.83,3.83,0,0,1,.27,1.82c-.11,1-.58,1.56-.62,1.52A14.37,14.37,0,0,0,647,304a3.76,3.76,0,0,0-.35-1.59,3.32,3.32,0,0,0-.52-.8c-.22-.27-.48-.44-.57-.34a.91.91,0,0,0-.21.75,4.3,4.3,0,0,0,.11,1,5.73,5.73,0,0,0,.57,1.57C646.49,305.37,646.94,305.79,646.88,305.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "586.09 247.61 622.03 304.09 641.68 290.73 608.58 222.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589,235.22c.15.06-.93,2.36-1.44,5.39s-.3,5.55-.46,5.57a15.73,15.73,0,0,1,1.9-11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.31,235.38c.15,0,0,2.48.41,5.48s1.16,5.34,1,5.39a18.58,18.58,0,0,1-1.42-10.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.94,247.44l-24.65-7.61c-29.74,37.87-27.75,79.48,20.12,104.11L468,314.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.35,241.4C432.57,250.61,424.72,270,426.64,289c2.11,20.82,15.87,41.12,41.09,46.73l169.53-33.89a51.52,51.52,0,0,0,39.37-64.89h0a51.51,51.51,0,0,0-61.54-35.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.35,241.4l1.57-.4,4.63-1.14,17.83-4.35L538,219.61l45.32-11,25.26-6.1,6.55-1.57,3.37-.64c.56-.11,1.12-.23,1.69-.32l1.72-.15c1.15-.09,2.3-.23,3.45-.29l3.5,0a27.44,27.44,0,0,1,3.5.24l1.76.18.88.1.87.17,3.49.71c1.16.27,2.29.66,3.44,1,.57.18,1.15.34,1.72.54l1.67.67,1.67.69a12.34,12.34,0,0,1,1.66.74l3.23,1.68c1.07.59,2.07,1.3,3.11,2,.51.34,1,.65,1.53,1l1.45,1.14,1.46,1.15.73.57.67.64a52.06,52.06,0,0,1,15.57,25.52,51.53,51.53,0,0,1-1.52,30.91,52.05,52.05,0,0,1-19.66,25,50.83,50.83,0,0,1-12.27,6.07c-4.32,1.51-8.81,2.17-13.18,3.09l-26,5.19L555,318.52l-87.18,17.39h-.09a62.32,62.32,0,0,1-12.87-4.57,50.4,50.4,0,0,1-18.91-16.49,58.06,58.06,0,0,1-5.5-10.18c-.36-.86-.64-1.75-1-2.61a23,23,0,0,1-.85-2.59c-.25-.87-.49-1.73-.73-2.59l-.54-2.57a22.71,22.71,0,0,1-.45-2.55c-.11-.84-.23-1.68-.34-2.51s-.12-1.66-.18-2.48-.11-1.63-.1-2.43A54.15,54.15,0,0,1,428.72,267a49.47,49.47,0,0,1,6-12.69,40.87,40.87,0,0,1,6.72-7.84c.52-.46,1-.93,1.47-1.31l1.38-1.05,1.16-.89,1-.65,1.85-1.16-1.82,1.21-1,.66-1.16.9L443,245.23c-.47.39-.94.85-1.46,1.32a40.87,40.87,0,0,0-6.65,7.85,49.23,49.23,0,0,0-5.95,12.66,54.38,54.38,0,0,0-2.41,17.27c0,.8,0,1.61.1,2.42s.1,1.64.2,2.47.22,1.66.34,2.5a22.78,22.78,0,0,0,.45,2.53c.18.84.36,1.7.54,2.56s.49,1.7.73,2.57a25.09,25.09,0,0,0,.85,2.58c.32.85.6,1.73,1,2.58a57.67,57.67,0,0,0,5.48,10.11,56.71,56.71,0,0,0,8.1,9.13A56,56,0,0,0,455,331a61.42,61.42,0,0,0,12.78,4.52h-.08L554.85,318l49.68-9.94,26-5.2c4.38-.93,8.86-1.58,13.11-3.08a49.93,49.93,0,0,0,12.14-6A51.53,51.53,0,0,0,675.25,269a51,51,0,0,0,1.51-30.6,51.56,51.56,0,0,0-15.4-25.28l-.67-.63L660,212l-1.44-1.13-1.44-1.13c-.48-.37-1-.67-1.52-1-1-.64-2-1.35-3.07-1.93l-3.2-1.67a17.16,17.16,0,0,0-1.64-.74l-1.66-.67-1.66-.68c-.56-.19-1.13-.35-1.7-.52-1.14-.33-2.26-.73-3.41-1l-3.45-.7-.86-.18-.88-.09-1.74-.18a27,27,0,0,0-3.47-.25l-3.46,0c-1.15.06-2.29.2-3.42.29l-1.71.15c-.56.08-1.12.2-1.68.31l-3.33.63L608.68,203l-25.25,6.07L538.1,220,472.45,235.7,454.59,240l-4.65,1.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.73,335.71l-22.36,50.84s105.5-10.17,101-66.56Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.19,222.16S477.46,172.94,413,193.67l35.37,47.73Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.8,200.52c21.77,16,35.08,78.56,24.59,98.43,61.7-18.05,74.64-71,74.64-71C675.43,186.41,620.8,200.52,620.8,200.52Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,312.46c.1.09-3.29,4.15-7.58,9.06s-7.86,8.81-8,8.71,3.28-4.15,7.58-9.06S435.9,312.36,436,312.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720,227.93s-.12.23-.38.67l-1.17,1.94-1.91,3.16c-.38.62-.79,1.29-1.22,2l-1.54,2.2c-1.09,1.55-2.28,3.29-3.63,5.15l-4.71,5.84c-.89,1-1.85,2-2.82,3.09s-1.93,2.19-3,3.23c-2.22,2.1-4.5,4.39-7.16,6.5A96,96,0,0,1,674,273.91a92,92,0,0,1-11.36,4.86c-2,.73-4.06,1.36-6.09,2.1a59.15,59.15,0,0,1-6.45,1.66c-17.48,3.87-36.75,7.83-57,12-40.47,8.36-77.12,15.82-103.66,21.18L458,322.06l-8.55,1.69-2.23.42c-.5.1-.76.13-.76.13l.75-.18,2.22-.48,8.53-1.78,31.4-6.48L593,294.05c20.22-4.2,39.5-8.15,57-12a61.36,61.36,0,0,0,6.38-1.62c2.07-.76,4.12-1.37,6.11-2.1a92.75,92.75,0,0,0,11.32-4.81,96.85,96.85,0,0,0,18.43-12.09c2.65-2.1,4.94-4.37,7.15-6.46,1.12-1,2.07-2.17,3.06-3.2s1.94-2.06,2.83-3.07l4.73-5.8c1.36-1.85,2.56-3.58,3.67-5.11l1.55-2.19,1.24-2,1.95-3.13c.53-.83.93-1.47,1.21-1.92S720,227.93,720,227.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.46,317.44s-.07-.06-.18-.2l-.49-.62-1.83-2.4-1.32-1.75c-.46-.65-.92-1.39-1.44-2.17-1-1.56-2.26-3.3-3.39-5.36l-1.85-3.2c-.64-1.11-1.2-2.33-1.83-3.56-1.31-2.44-2.44-5.17-3.69-8a118.22,118.22,0,0,1-8.76-39.35c-.08-3.11-.22-6.06-.07-8.83.06-1.38,0-2.72.15-4s.22-2.51.32-3.68c.15-2.35.54-4.45.79-6.3.15-.92.25-1.78.4-2.57s.31-1.49.45-2.14c.27-1.26.48-2.24.64-3,.07-.31.13-.56.18-.77s.07-.26.08-.25a1.85,1.85,0,0,1,0,.27c0,.2-.08.46-.13.77l-.54,3c-.12.65-.26,1.36-.41,2.14s-.22,1.65-.35,2.58c-.22,1.85-.58,3.94-.71,6.28-.09,1.17-.19,2.4-.28,3.67s-.08,2.61-.12,4c-.13,2.76,0,5.7.11,8.8A120.08,120.08,0,0,0,543.88,290c1.23,2.84,2.34,5.57,3.63,8,.63,1.23,1.18,2.44,1.8,3.56l1.82,3.2c1.1,2.07,2.32,3.82,3.31,5.39.51.79,1,1.53,1.41,2.19s.89,1.23,1.27,1.77c.75,1,1.33,1.87,1.76,2.46l.44.65A1.12,1.12,0,0,1,559.46,317.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.84,265,405.51,287s-.47,10.39,2.14,10.47c2.18.07,81.23-14.19,106.87-18.83a6.92,6.92,0,0,0,5.3-9.1h0A7,7,0,0,0,511.84,265Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 593.28,
    cy: 255.15,
    rx: 23.62,
    ry: 25.41,
    transform: "translate(337.29 848.07) rotate(-89.92)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.69,255.19a2.59,2.59,0,0,1,0-.4c0-.29-.06-.67-.09-1.16,0-.26,0-.54-.06-.86s-.11-.65-.18-1-.13-.76-.2-1.18-.24-.86-.37-1.33a23,23,0,0,0-1.09-3,24.28,24.28,0,0,0-8.43-9.91,25.89,25.89,0,0,0-10.42-4.16,24,24,0,0,0-3.08-.32c-.53,0-1.06-.07-1.59-.06l-1.61.08-.81,0-.82.11-1.64.24-1.63.39-.83.19-.8.28a25,25,0,0,0-11.7,7.9,22,22,0,0,0,0,28.27,25,25,0,0,0,11.67,7.93l.81.28.83.2,1.63.39,1.64.24.81.12.82,0,1.61.08c.53,0,1.06,0,1.58-.05a23.61,23.61,0,0,0,3.08-.32A25.51,25.51,0,0,0,608.17,274a22.78,22.78,0,0,0,9.57-12.91c.12-.47.27-.9.36-1.32s.15-.82.21-1.19.13-.7.18-1,0-.6.06-.85q.06-.74.09-1.17a2.94,2.94,0,0,1,.05-.39,2.38,2.38,0,0,1,0,.4l0,1.16c0,.26,0,.55,0,.87s-.1.66-.16,1-.12.77-.18,1.2-.23.86-.35,1.34a22.22,22.22,0,0,1-1.07,3.07,24.27,24.27,0,0,1-1.87,3.4,24.58,24.58,0,0,1-6.61,6.69,26,26,0,0,1-10.57,4.25,24.57,24.57,0,0,1-3.13.33c-.53,0-1.07.07-1.61.06l-1.63-.07-.83,0-.83-.12-1.67-.24-1.66-.39-.84-.2-.82-.28a25.47,25.47,0,0,1-11.93-8.07,22.46,22.46,0,0,1,0-28.91,25.55,25.55,0,0,1,12-8l.82-.27.84-.2,1.67-.39,1.67-.24.82-.11.83,0,1.64-.07c.54,0,1.08.05,1.61.07a22.88,22.88,0,0,1,3.13.34A25.88,25.88,0,0,1,608.43,236a24.4,24.4,0,0,1,6.59,6.71,20.85,20.85,0,0,1,2.93,6.48c.12.47.25.91.34,1.34s.13.83.18,1.2.11.71.16,1,0,.6,0,.86c0,.5,0,.88,0,1.17A2.47,2.47,0,0,1,618.69,255.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.68,340.53c-2.94,1.3-6.29,1.14-9.48.79s-6.42-.89-9.57-.27c-4.88,1-9.18,4.64-14.15,4.38-6.89-.36-11-7.78-17.09-11-7.4-4-17.33-1.5-23.29-8.86a14.24,14.24,0,0,1-1.43-15.76C222,302,232,300.7,239.8,303.51c6.71,2.41,12.2,7.3,17.43,12.14,1.78,1.65,3.56,3.31,5.4,4.9a28.61,28.61,0,0,0,21.53,6.79h0a14.54,14.54,0,0,1,10.44,3,6.11,6.11,0,0,1,1.82,2.39h0a5.87,5.87,0,0,1,.53,2.88C296.71,338.06,295.06,339.48,292.68,340.53Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.68,340.53c-2.94,1.3-6.29,1.14-9.48.79s-6.42-.89-9.57-.27c-4.88,1-9.18,4.64-14.15,4.38-6.89-.36-11-7.78-17.09-11-7.4-4-17.33-1.5-23.29-8.86a14.24,14.24,0,0,1-1.43-15.76C222,302,232,300.7,239.8,303.51c6.71,2.41,12.2,7.3,17.43,12.14,1.78,1.65,3.56,3.31,5.4,4.9a28.61,28.61,0,0,0,21.53,6.79h0a14.54,14.54,0,0,1,10.44,3,6.11,6.11,0,0,1,1.82,2.39h0a5.87,5.87,0,0,1,.53,2.88C296.71,338.06,295.06,339.48,292.68,340.53Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.53,337.21c-2-3.47-8-3.55-11.62-1.79s-6.08,5.12-8.51,8.29-5.18,6.4-9,7.7c-4.07,1.39-8.5.28-12.8.31s-9.33,2.09-10,6.33a7.94,7.94,0,0,0,2.14,6.84,19.59,19.59,0,0,0,5.92,3.84,48.64,48.64,0,0,0,18,3.52,25.89,25.89,0,0,0,20.32-10.43c4.66-6.38,10.91-17.48,5.44-24.61",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.53,337.21c-2-3.47-8-3.55-11.62-1.79s-6.08,5.12-8.51,8.29-5.18,6.4-9,7.7c-4.07,1.39-8.5.28-12.8.31s-9.33,2.09-10,6.33a7.94,7.94,0,0,0,2.14,6.84,19.59,19.59,0,0,0,5.92,3.84,48.64,48.64,0,0,0,18,3.52,25.89,25.89,0,0,0,20.32-10.43c4.66-6.38,10.91-17.48,5.44-24.61",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.53,357.63a11.41,11.41,0,0,0-4.67,3.13,5.63,5.63,0,0,0-1.19,5.31,3.79,3.79,0,0,0,4.51,2.44c.95-.33,1.73-1.1,2.72-1.27,1.58-.26,3,1.1,4.54,1.38,2.35.41,4.56-1.95,4.54-4.34s-2-4.19-3.89-5.6a7.73,7.73,0,0,0-6.56-1.05",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.53,357.63a11.41,11.41,0,0,0-4.67,3.13,5.63,5.63,0,0,0-1.19,5.31,3.79,3.79,0,0,0,4.51,2.44c.95-.33,1.73-1.1,2.72-1.27,1.58-.26,3,1.1,4.54,1.38,2.35.41,4.56-1.95,4.54-4.34s-2-4.19-3.89-5.6a7.73,7.73,0,0,0-6.56-1.05",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M507.17,194.39c-8.17-.4-12.2,5.76-16.77,7s-9.56,1.46-13.95-.32c-5.7-2.32-9.59-7.57-14.58-11.16-10-7.21-24.85-6.78-34.43,1-.22,5.45,4.44,9.76,8.95,12.82s17,7.46,18.63,12.68c1.2,3.9-7.22,7.18-5.1,10.67s9.13,3.14,13,2.47c24.42-4.2,15.85,3.27,23.41,2.58,0,0,15.83-4,28.24-6.06",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "589.48 338.17 581.55 319.74 598.48 312.41 604.37 335.53 590.2 338.17",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.36,332.53l5,16.15s18.07.38,19.28,3.28l-31,10.73-8.75-24.84Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M599.28,350.65a1.34,1.34,0,0,0-.37,1.75,1.28,1.28,0,0,0,1.72.39,1.41,1.41,0,0,0,.39-1.85,1.33,1.33,0,0,0-1.84-.21",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.64,362.69l-.78-2.54,30-9.34s1.59.12,1.77,1.15Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M609.77,348.35c0,.15-.69.48-1.26,1.22s-.76,1.52-.92,1.51-.23-1,.48-1.85S609.75,348.2,609.77,348.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.48,348.56c.08.14-.48.62-.77,1.44s-.21,1.54-.36,1.59-.55-.78-.17-1.79S613.43,348.42,613.48,348.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.67,351.81c-.13.08-.6-.6-.5-1.57s.7-1.53.8-1.43-.17.7-.24,1.49S616.82,351.74,616.67,351.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.23,344.79c0,.16-.78.19-1.62.55s-1.4.85-1.53.75.33-.86,1.32-1.27S608.26,344.65,608.23,344.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.17,341.55a3,3,0,0,1-1.56.53,7.8,7.8,0,0,1-1.79.07,8.18,8.18,0,0,1-1.05-.17,1.84,1.84,0,0,1-.6-.2.7.7,0,0,1-.35-.78.91.91,0,0,1,.55-.58,2.45,2.45,0,0,1,.6-.12,6.49,6.49,0,0,1,1.08,0,5.8,5.8,0,0,1,1.76.44c1,.42,1.39.9,1.35.95s-.57-.28-1.49-.58a6.32,6.32,0,0,0-1.65-.3,6.66,6.66,0,0,0-1,0c-.36,0-.64.12-.67.29s0,.09.1.17a1.67,1.67,0,0,0,.43.14,7.66,7.66,0,0,0,1,.19,9.13,9.13,0,0,0,1.7.05A12,12,0,0,1,607.17,341.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.05,341.84s-.54-.4-.93-1.36a5.16,5.16,0,0,1-.38-1.77,5.76,5.76,0,0,1,.07-1.08,1.32,1.32,0,0,1,.72-1.12.75.75,0,0,1,.79.2,2.22,2.22,0,0,1,.36.52,3.58,3.58,0,0,1,.36,1,3.64,3.64,0,0,1-.1,1.83c-.33,1-.9,1.41-.93,1.37a15.61,15.61,0,0,0,.55-1.47,3.86,3.86,0,0,0,0-1.62,3.47,3.47,0,0,0-.34-.89c-.16-.31-.38-.53-.49-.46a.93.93,0,0,0-.36.7,5.51,5.51,0,0,0-.1,1,6.05,6.05,0,0,0,.24,1.65C606.76,341.28,607.12,341.79,607.05,341.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.51,195s-14.67,29.05-4.81,35.86,55.91,41.41,55.91,41.41L583.1,335l22-9-18.33-73.42L540.49,211Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565,260.76c.13.1-1.39,2.12-2.52,5s-1.44,5.37-1.6,5.35A15.78,15.78,0,0,1,565,260.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.37,260.16c.15,0-.51,2.42-.73,5.44s0,5.47-.13,5.49a14.56,14.56,0,0,1-.39-5.53A14.23,14.23,0,0,1,561.37,260.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.32,334.06a1.31,1.31,0,0,1-.14-.31c-.1-.23-.22-.54-.38-.94-.34-.85-.81-2.06-1.42-3.62-1.21-3.16-3-7.76-5.08-13.5s-4.63-12.63-7.26-20.41c-.66-1.94-1.31-3.95-1.95-6S567.86,285.1,567,283c-1.68-4.17-3.69-8.39-5.89-12.67l.07.07c-2.47-2.09-5.08-4.28-7.76-6.48-2.09-1.72-4.16-3.41-6.25-5l-6.2-4.7c-4.06-3.09-8-6.06-11.81-8.77s-7.57-5.09-11-7.46a64.15,64.15,0,0,1-9.07-7.25,22,22,0,0,1-3.22-3.94,14.6,14.6,0,0,1-1.76-4.19,17.11,17.11,0,0,1-.09-7.22,25.75,25.75,0,0,1,1.28-4.39c.18-.49.35-.85.45-1.1a2.21,2.21,0,0,1,.18-.37s0,.14-.13.39-.24.62-.4,1.11a28.63,28.63,0,0,0-1.18,4.4,17.1,17.1,0,0,0,.18,7.11,14.3,14.3,0,0,0,1.75,4.09,22.46,22.46,0,0,0,3.2,3.85,65.51,65.51,0,0,0,9.06,7.16c3.44,2.34,7.23,4.7,11.05,7.42s7.77,5.66,11.84,8.75l6.2,4.7c2.11,1.6,4.18,3.29,6.27,5,2.68,2.21,5.29,4.4,7.76,6.5l0,0,0,.05c2.2,4.3,4.21,8.53,5.89,12.73a64.22,64.22,0,0,1,2.08,6.29c.63,2.06,1.28,4.06,1.92,6,2.6,7.78,5.08,14.67,7.15,20.43l4.94,13.55c.57,1.57,1,2.8,1.33,3.66l.33,1A1.31,1.31,0,0,1,585.32,334.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "526.6 204.3 554.96 208.32 569.5 212.02 549.59 219.16 526.6 204.3",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.88,202.25a3.11,3.11,0,0,1-.59.68,19.06,19.06,0,0,1-1.82,1.64,28.93,28.93,0,0,1-14.73,6.15,18.79,18.79,0,0,1-2.44.14,2.69,2.69,0,0,1-.9-.06c0-.09,1.27-.13,3.29-.45a32.86,32.86,0,0,0,7.65-2.15,33.46,33.46,0,0,0,6.91-3.93C490.89,203.06,491.82,202.19,491.88,202.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.24,160.73l-5.47,41.12s18.18-1.19,31,3.07,20.7,4.14,20.7,4.14l-2.68-25.58,9.57-21,4.21,24.55,19.66,20.24,12.81-2.9-13.28-22.24-9.22-45.32v0a16.9,16.9,0,0,0-5.8-9.63l-.37-.3-19.3-10.76-6.48.13a101.67,101.67,0,0,0-16.32,1.68,16.53,16.53,0,0,0-8.83,4.73h0a20.46,20.46,0,0,0-4.51,8.41Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.55,143.53a7.42,7.42,0,0,1-.48,1.33l-1.46,3.52c-1.26,3-3,7.05-5,11.55l-5.12,11.51c-.64,1.39-1.18,2.55-1.59,3.47a9.78,9.78,0,0,1-.63,1.25,5.56,5.56,0,0,1,.44-1.33c.33-.85.82-2.05,1.44-3.54,1.24-3,3-7.06,5-11.57s3.81-8.56,5.15-11.49l1.62-3.46A6.7,6.7,0,0,1,573.55,143.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519,136.37c3.76,10.48,11,34.41,14.52,43.64a16.87,16.87,0,0,0,5.24,7.13l39,27.59,9-11.71-29.23-28.2-15.76-46.69c-2.22-6.23-11.43-9.61-17.15-6.28h0C520.28,124.42,517.31,131.57,519,136.37Z",
    style: {
      fill: "#6C5DD3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.53,130.07s.11.27.3.8l.84,2.38c.72,2.11,1.78,5.16,3.11,9.05l11,32.45-.06-.09L587,202.83l.16.16-.14.18-6.48,8.43c-.87,1.12-1.73,2.25-2.53,3.29l-.15.2-.21-.15-29.94-21.57L541,188.54l-1.61-1.16a14.3,14.3,0,0,1-1.56-1.23,15.17,15.17,0,0,1-2.48-3,17,17,0,0,1-1.63-3.35l-1.29-3.32c-.82-2.17-1.6-4.26-2.32-6.27-2.87-8-5-14.54-6.42-19.06-.7-2.25-1.24-4-1.62-5.21-.17-.58-.31-1-.4-1.36a4.63,4.63,0,0,1-.12-.47s.06.15.17.46.25.77.45,1.34c.39,1.2,1,2.94,1.71,5.18,1.49,4.5,3.65,11,6.57,19,.73,2,1.52,4.08,2.35,6.25.43,1.08.86,2.19,1.3,3.31a16.82,16.82,0,0,0,1.61,3.27,15,15,0,0,0,2.42,2.88,12.88,12.88,0,0,0,1.52,1.19l1.62,1.16L548,193l30,21.53-.35,0,2.53-3.29,6.48-8.42,0,.34L557.44,175l0,0,0-.05c-4.5-13.47-8.23-24.66-10.85-32.51l-3-9.09-.77-2.39C542.6,130.35,542.53,130.07,542.53,130.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.8,124.37c-.06.06-.71-.62-2-1.41a11.3,11.3,0,0,0-11.09-.53c-1.34.66-2.05,1.28-2.11,1.21a5.68,5.68,0,0,1,1.94-1.54,10.76,10.76,0,0,1,11.46.55A5.83,5.83,0,0,1,538.8,124.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.62,182.74c0,.16-1.85,0-4,.5s-3.7,1.52-3.79,1.38a7,7,0,0,1,3.67-1.89A6.88,6.88,0,0,1,589.62,182.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.13,152.13a1.81,1.81,0,0,1-.39.1,9.19,9.19,0,0,1-1.08.17,10.82,10.82,0,0,1-3.6-.23A10.68,10.68,0,0,1,514.9,150a1.77,1.77,0,0,1-.29-.28,14.51,14.51,0,0,0,4.5,2.24A15.57,15.57,0,0,0,524.13,152.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.17,161.05a18.6,18.6,0,0,0-1.85-1.09,13.86,13.86,0,0,0-5-1.27,31.31,31.31,0,0,0-5.19.11l-1.57.15a4.16,4.16,0,0,1-.58,0,2.82,2.82,0,0,1,.57-.11c.37-.06.9-.13,1.57-.21a26.85,26.85,0,0,1,5.21-.18,13.22,13.22,0,0,1,5,1.35,8.94,8.94,0,0,1,1.34.84A2.39,2.39,0,0,1,527.17,161.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M522.13,145.9s1,15.64,2.17,22.87,3.45,14.59,8.63,19.76,12.62,7.51,19.85,9c-2.34-1.76-4.62-3.57-6.87-5.44-2.89-2.4-7.13-4.75-9.46-7.71-4.48-5.69-5.45-12.88-7.76-19.74-2.12-6.34-4.43-12.37-6.56-18.7"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M549.29,152a3,3,0,0,1-.82.41,6.72,6.72,0,0,1-2.5.38c-2.15,0-5-1-8.24-.71a17.7,17.7,0,0,0-7.79,2.5,19.45,19.45,0,0,0-2.05,1.44l-.52.44c-.12.1-.19.15-.19.14a12.76,12.76,0,0,1,2.68-2.15,17.35,17.35,0,0,1,7.86-2.58c3.28-.31,6.15.76,8.25.77a7.06,7.06,0,0,0,2.47-.3C549,152.2,549.28,152,549.29,152Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.39,144.45a1.23,1.23,0,0,1-.2.13l-.57.33c-.5.29-1.24.67-2.17,1.11a39.4,39.4,0,0,1-15.57,3.7c-1,0-1.87,0-2.44,0l-.66,0a1.22,1.22,0,0,1-.23,0l.23,0h.66c.57,0,1.41,0,2.43-.05a42.68,42.68,0,0,0,7.93-1.1,43.91,43.91,0,0,0,7.59-2.58c.93-.42,1.68-.79,2.19-1l.59-.3C546.31,144.47,546.38,144.44,546.39,144.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.54,152.65l-.27-.06a6.93,6.93,0,0,1-.76-.26,8.6,8.6,0,0,1-2.44-1.62c-1.9-1.62-3.65-4.66-6.6-7A22.16,22.16,0,0,0,547.05,139l-.79-.08a.72.72,0,0,1-.27,0,16.5,16.5,0,0,1,4,.48,21.72,21.72,0,0,1,8.64,4.2,24.54,24.54,0,0,1,3.71,3.82,29.72,29.72,0,0,0,2.86,3.24,9,9,0,0,0,2.38,1.65C568.17,152.55,568.55,152.62,568.54,152.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.37,157.42a7.14,7.14,0,0,1-.84-.24,7.75,7.75,0,0,1-2-1.23,20.32,20.32,0,0,1-2.45-2.51,23.59,23.59,0,0,0-3-3,8,8,0,0,0-3.85-1.65,14.57,14.57,0,0,0-3.46-.07c-1,.09-1.79.21-2.34.28l-.64.09a.73.73,0,0,1-.22,0,.64.64,0,0,1,.21-.06l.63-.13c.55-.1,1.35-.24,2.34-.34a13.76,13.76,0,0,1,3.51,0,8,8,0,0,1,4,1.68,22,22,0,0,1,3,3.08,23.85,23.85,0,0,0,2.4,2.52,8.18,8.18,0,0,0,2,1.26C567.08,157.31,567.37,157.4,567.37,157.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.69,154.2a6.74,6.74,0,0,0-2.22-.22,9.16,9.16,0,0,0-2.37.53c-.86.3-1.78.74-2.75,1.18a14.79,14.79,0,0,1-2.84,1,7.1,7.1,0,0,1-2.47.13,4.67,4.67,0,0,1-1.59-.52A2.65,2.65,0,0,1,568,156a5.25,5.25,0,0,0,2.1.72,7,7,0,0,0,2.4-.17,15,15,0,0,0,2.8-1c1-.44,1.9-.87,2.78-1.17a9.24,9.24,0,0,1,2.42-.5,5.35,5.35,0,0,1,1.66.16A2.52,2.52,0,0,1,582.69,154.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.27,159.64a5,5,0,0,0-2.76-1,7.55,7.55,0,0,0-3.14.57,17.82,17.82,0,0,0-3.41,2,23.63,23.63,0,0,1-3.39,2.11,8.56,8.56,0,0,1-3.15.85,5.39,5.39,0,0,1-2.17-.32,3.27,3.27,0,0,1-.72-.38,5.54,5.54,0,0,0,2.88.55,8.7,8.7,0,0,0,3.08-.87,26.17,26.17,0,0,0,3.35-2.11,17.83,17.83,0,0,1,3.46-2,7.54,7.54,0,0,1,3.22-.54,4.85,4.85,0,0,1,2.11.62A3,3,0,0,1,584.27,159.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M567.64,175.74c2-8.19,2.44-17.06,2.73-25.49-.71,2.95-2.52,5.5-3.64,8.33-.54,1.34-1.39,3.78-1.39,3.78l2.26,13.18"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M554.44,79.4a4.14,4.14,0,0,1-2.77,3.32c-.82.27-1.72.27-2.53.58a1.9,1.9,0,0,0-1.38,1.94c.14.64.73,1.05,1.21,1.48s.92,1.11.64,1.69-1.23.7-1.71,1.23a1.66,1.66,0,0,0,.11,2.07,7.5,7.5,0,0,0,1.77,1.39,2.94,2.94,0,0,1,1.36,1.73",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.1,92.39c2.2-4.65.6-10.44-2.83-14.28s-8.35-6-13.29-7.43c-.71-.2-1.59-.35-2.09.2a1.41,1.41,0,0,0,.13,1.78,4,4,0,0,0,1.66,1,15.57,15.57,0,0,0-6.44-1.75,4.13,4.13,0,0,0-2.27.48,1.88,1.88,0,0,0-.89,2A1.23,1.23,0,0,0,560,75a9.46,9.46,0,0,0-6.11,1.43c-1.28.82-2.45,2.24-2.14,3.73a23.1,23.1,0,0,0,1.12,2.43c.53,1.55-.24,3.21-.83,4.73a14.69,14.69,0,0,0-1,7.48,8.67,8.67,0,0,0,4,6.22",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.43,131.6a10.24,10.24,0,0,1-7.17-12.79l9.18-31.08a14.68,14.68,0,0,1,18.37-10.29l.72.26a14.79,14.79,0,0,1,9.24,17.79c-1.89,6.91-4.07,14.53-5.42,18.12-2.79,7.43-10.67,5.89-10.67,5.89l-1.94,5.57a10.23,10.23,0,0,1-12.31,6.53Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.73,119.4a18.47,18.47,0,0,1-8.73-6.28s.36,6.2,8,8.22Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.32,82c-.61-1.34-1.38-4.26-2.42-5.31s-2.73-.7-4.15-.3a4.81,4.81,0,0,0-3.19,3c-2,5.37-2.2,10.45-3.66,15.73a1.92,1.92,0,0,0-.09,1.08c.28.89,1.26,1.21,2.19,1.35,2.29.33,3.46-1.34,4.54-3.35a24.37,24.37,0,0,0,.8-3.72A10.09,10.09,0,0,1,566,82.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.73,92c-.1-.1-4.58-3.37-6.26,1.79s3.85,5.79,3.91,5.64S556.73,92,556.73,92Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.44,97s-.11,0-.29.06a1,1,0,0,1-.68-.21,2.33,2.33,0,0,1-.37-2.33,3.16,3.16,0,0,1,.67-1.21,1.11,1.11,0,0,1,.9-.47.5.5,0,0,1,.45.42c0,.17,0,.26,0,.28s.14-.05.17-.28a.62.62,0,0,0-.1-.39.71.71,0,0,0-.46-.29,1.34,1.34,0,0,0-1.2.5,3.31,3.31,0,0,0-.78,1.33,2.47,2.47,0,0,0,.59,2.66,1,1,0,0,0,.86.13C553.39,97.09,553.45,97,553.44,97Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.33,83.11c2.54-1.74,5.16-.88,6.91.14s3.23,2.46,5,3.39,4.14,1.25,5.74,0a5.49,5.49,0,0,0,1.83-4,10.93,10.93,0,0,0-2.62-8c-.49-.57-1.25-1.12-1.94-.82-.85.38-.71,1.62-.44,2.51,0,0-8.68-3.21-14-1.36S564.33,83.11,564.33,83.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.59,70.58s.1.38.37,1a8,8,0,0,0,1.65,2.31,13.07,13.07,0,0,0,3.46,2.42,10.73,10.73,0,0,0,2.36.79c.85.19,1.76.32,2.68.57a6.22,6.22,0,0,1,2.51,1.27,5.49,5.49,0,0,1,1.51,2.14,4.89,4.89,0,0,1,.31,2.36,4.39,4.39,0,0,1-.74,1.92,4.48,4.48,0,0,1-2.35,1.76,3.21,3.21,0,0,1-.8.12c-.18,0-.28,0-.28,0s.39,0,1-.27a4.47,4.47,0,0,0,2.14-1.76,4.3,4.3,0,0,0,.64-1.8,4.45,4.45,0,0,0-.33-2.15,5.17,5.17,0,0,0-1.41-2A5.87,5.87,0,0,0,578,78.11c-.88-.24-1.79-.38-2.66-.58a10.5,10.5,0,0,1-2.44-.85,12.57,12.57,0,0,1-3.51-2.57,7.26,7.26,0,0,1-1.58-2.47,3.29,3.29,0,0,1-.19-.78A.75.75,0,0,1,567.59,70.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.86,72.14s.13.38.42,1a7.68,7.68,0,0,0,1.78,2.37,10.76,10.76,0,0,0,3.83,2.17,36.55,36.55,0,0,0,5.34,1.24,20.33,20.33,0,0,1,5.35,1.54,3.71,3.71,0,0,1,1.75,1.77,3.55,3.55,0,0,1,.12,2.17,4.32,4.32,0,0,1-1.85,2.45,4.19,4.19,0,0,1-.74.39.93.93,0,0,1-.28.09s.35-.2.92-.63a4.22,4.22,0,0,0,1.63-2.37A3.15,3.15,0,0,0,580,82.4a3.31,3.31,0,0,0-1.6-1.55,20.83,20.83,0,0,0-5.24-1.46,33.77,33.77,0,0,1-5.39-1.3,10.62,10.62,0,0,1-3.91-2.32,7.26,7.26,0,0,1-1.72-2.54,4.34,4.34,0,0,1-.23-.8A.71.71,0,0,1,561.86,72.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.79,99.08a1.22,1.22,0,0,1-1.52.78,1.17,1.17,0,0,1-.84-1.46,1.24,1.24,0,0,1,1.53-.79A1.18,1.18,0,0,1,578.79,99.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581,98.42c-.2.1-.85-.85-2.11-1.28s-2.38-.13-2.46-.33.19-.31.7-.46a3.38,3.38,0,0,1,3.65,1.28C581.07,98.06,581.1,98.38,581,98.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.43,95.52a1.23,1.23,0,0,1-1.53.78,1.17,1.17,0,0,1-.83-1.46,1.23,1.23,0,0,1,1.52-.79A1.18,1.18,0,0,1,566.43,95.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.63,94.38c-.2.11-.85-.85-2.1-1.28s-2.39-.13-2.47-.33.2-.31.7-.46a3.35,3.35,0,0,1,2,.07,3.25,3.25,0,0,1,1.61,1.21C568.69,94,568.72,94.34,568.63,94.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570,105.24a8.8,8.8,0,0,1,2.16.34c.33.08.65.12.78-.08a1.74,1.74,0,0,0,.12-1c0-.88-.07-1.8-.1-2.76a43.66,43.66,0,0,1,.09-7.1,45.78,45.78,0,0,1,.48,7.09c0,1,0,1.88,0,2.76a1.92,1.92,0,0,1-.27,1.31.85.85,0,0,1-.68.29A2.11,2.11,0,0,1,572,106,8.75,8.75,0,0,1,570,105.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566,104.83c.2,0-.27,1.41.56,2.78s2.33,1.72,2.27,1.92-.41.15-1,0a3.57,3.57,0,0,1-1.92-1.52,3.07,3.07,0,0,1-.39-2.3C565.61,105.07,565.87,104.79,566,104.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.66,89.59c-.25.3-1.44-.29-3-.63s-2.85-.34-2.94-.71c0-.18.28-.43.87-.59a5.22,5.22,0,0,1,4.5,1C570.59,89.09,570.77,89.45,570.66,89.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.81,94.64c-.32.21-1.08-.38-2.11-.76s-2-.47-2.08-.84c0-.17.2-.41.67-.55a3.28,3.28,0,0,1,3.38,1.29C581.93,94.2,582,94.54,581.81,94.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.24,205.59a5,5,0,0,1,3.2,5.64l-6.76,2.67-1.54-6.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.5,205.57s13.53-1.4,22,1.59,19.07,5.22,23.74,4.17a11.9,11.9,0,0,0,6.37-4s-13.48-1.62-19.83-3.67c-4.27-1.38-12.71-10.95-28.33-8.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.71,210.47a9.16,9.16,0,0,0-2.18-3.27l.12.16a21.17,21.17,0,0,0-4.2.61,7,7,0,0,0-3.55,2.2,1.85,1.85,0,0,0-.5,1.26,2.24,2.24,0,0,0,1.06,1.46,12.63,12.63,0,0,0,4.25,2.53,4.31,4.31,0,0,0,4.54-1.17A4.11,4.11,0,0,0,555.71,210.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.89,210a1.87,1.87,0,0,1,.43-.77,4.49,4.49,0,0,1,2-1.27,7.57,7.57,0,0,1,3.54-.3,5.18,5.18,0,0,1,3.6,2.34,3.79,3.79,0,0,1,.57,2.2,3.83,3.83,0,0,1-.75,2,3.32,3.32,0,0,1-1.55,1.13,4.09,4.09,0,0,1-1.66.2,8.07,8.07,0,0,1-2.33-.58c-.26-.1-.46-.19-.6-.26a.74.74,0,0,1-.2-.11l.22.07.61.22a8.42,8.42,0,0,0,2.31.51,3.41,3.41,0,0,0,3-1.29,3.48,3.48,0,0,0,.16-4,5,5,0,0,0-3.46-2.25,7.44,7.44,0,0,0-3.46.25,4.64,4.64,0,0,0-2,1.18A4.14,4.14,0,0,0,545.89,210Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.75,210.22a8,8,0,0,0-.8-.7,7.09,7.09,0,0,0-1-.51,2.65,2.65,0,0,1,1.75,1.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.94,210.32s-.31-.31-.73-.66-.79-.58-.78-.6a2.52,2.52,0,0,1,.85.52A2.64,2.64,0,0,1,550.94,210.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.83,215s-.05-.23-.16-.59a5.34,5.34,0,0,0-.62-1.3,5.14,5.14,0,0,0-1-1.06c-.29-.24-.49-.36-.48-.37a3,3,0,0,1,.53.31,4.58,4.58,0,0,1,1,1.07,4.41,4.41,0,0,1,.6,1.33A2.86,2.86,0,0,1,551.83,215Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.05,213.25a5,5,0,0,1,0-.58,7.4,7.4,0,0,0-.1-1.39,6.72,6.72,0,0,0-.39-1.33c-.13-.33-.23-.53-.22-.54s0,0,.09.13a4.06,4.06,0,0,1,.2.38,5.85,5.85,0,0,1,.42,1.35,5.39,5.39,0,0,1,.07,1.4,3.2,3.2,0,0,1,0,.43A1,1,0,0,1,554.05,213.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.06,209.08a11.84,11.84,0,0,0-5.52,3.92,3.29,3.29,0,0,1,.56-.85,9.07,9.07,0,0,1,4-2.82A3.43,3.43,0,0,1,554.06,209.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.71,208a7,7,0,0,0-1.85,2.09,7.18,7.18,0,0,0-.73,2.69,2.18,2.18,0,0,1,0-.84,4.91,4.91,0,0,1,.58-1.95,5.25,5.25,0,0,1,1.31-1.57A2.07,2.07,0,0,1,550.71,208Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.42,215s-.06-.33-.26-.81a4.5,4.5,0,0,0-1.19-1.61c-1.22-1-2.45-1.55-2.4-1.63a3.88,3.88,0,0,1,.79.33,8.12,8.12,0,0,1,1.75,1.14,4.16,4.16,0,0,1,1.19,1.72A1.72,1.72,0,0,1,554.42,215Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526,207.85a6.64,6.64,0,0,1-1.33-.25c-.85-.19-2.07-.46-3.59-.75a83.17,83.17,0,0,0-12-1.4,22,22,0,0,0-6.56.53,13.53,13.53,0,0,0-4.78,2.37,18.15,18.15,0,0,0-3.4,3.63,4.71,4.71,0,0,1,.66-1.19,13,13,0,0,1,2.51-2.73,13.33,13.33,0,0,1,4.89-2.54,21.68,21.68,0,0,1,6.7-.59,70.29,70.29,0,0,1,12.07,1.56c1.52.34,2.74.67,3.57.92A6,6,0,0,1,526,207.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.59,194.29a4.44,4.44,0,0,1,.69-.54,11.84,11.84,0,0,1,2.19-1.2,14.39,14.39,0,0,1,9.07-.7,13.51,13.51,0,0,1,5.65,2.92,28.85,28.85,0,0,1,4.75,5.54,77.63,77.63,0,0,0,4.78,6.41,57.51,57.51,0,0,0,6,6.1c4.42,3.85,9.2,7,14,8.54a22.21,22.21,0,0,0,7.06,1.17,11,11,0,0,0,5.95-1.47,14.06,14.06,0,0,0,3.72-3.53c.93-1.21,1.66-2.32,2.26-3.22l1.37-2.08a6.17,6.17,0,0,1,.5-.71,4.64,4.64,0,0,1-.42.77l-1.28,2.13c-.57.92-1.28,2-2.2,3.28a14,14,0,0,1-3.75,3.67,11.41,11.41,0,0,1-6.15,1.6,22.45,22.45,0,0,1-7.21-1.15c-4.93-1.58-9.77-4.72-14.23-8.6a56.72,56.72,0,0,1-6.06-6.17,75,75,0,0,1-4.78-6.47,29.59,29.59,0,0,0-4.64-5.49,13.17,13.17,0,0,0-5.46-2.88,14.46,14.46,0,0,0-8.9.53A19.5,19.5,0,0,0,426.59,194.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.5,185.42l-.7,0c-.46,0-1.11.06-1.92.15a25.09,25.09,0,0,0-11.7,4.51c-.65.47-1.17.88-1.52,1.17l-.54.45a18.19,18.19,0,0,1,2-1.68,24.1,24.1,0,0,1,11.73-4.52A19.71,19.71,0,0,1,451.5,185.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.55,195.14l-.73.1c-.48.06-1.16.17-2,.34a27,27,0,0,0-6.29,2.12,27.34,27.34,0,0,0-5.6,3.59c-.65.54-1.16,1-1.5,1.34l-.54.51a21.09,21.09,0,0,1,2-1.91,26.92,26.92,0,0,1,5.59-3.63,26.48,26.48,0,0,1,6.33-2.09A21.71,21.71,0,0,1,467.55,195.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.06,217.91a7.61,7.61,0,0,1-.14-.77,11.11,11.11,0,0,1-.07-2.12,15.82,15.82,0,0,1,2-6.67,32.49,32.49,0,0,1,4.15-5.64c1.19-1.35,2-2.14,2-2.14l-.51.59-1.4,1.59A34.46,34.46,0,0,0,469,208.4a16.19,16.19,0,0,0-2.07,6.62,11.57,11.57,0,0,0,0,2.12c0,.25.06.44.07.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.66,207.83a4.87,4.87,0,0,1-.27-.77,8.57,8.57,0,0,1-.07-3.9,4.18,4.18,0,0,1,.24-.77s-.07.3-.17.79a9.42,9.42,0,0,0,.08,3.86C484.58,207.53,484.67,207.82,484.66,207.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.74,220a12.48,12.48,0,0,1-1.6-1.2,15.58,15.58,0,0,1-5-8.12,11.94,11.94,0,0,1-.33-2s0,.19.1.53.15.83.3,1.42a16.27,16.27,0,0,0,4.95,8.09,14.11,14.11,0,0,0,1.13.92C487.59,219.89,487.74,220,487.74,220Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.23,206.18s-.51-.23-1.3-.69a25.11,25.11,0,0,1-2.92-2,25.61,25.61,0,0,1-2.62-2.39c-.62-.66-1-1.11-1-1.11l.28.28.74.78a29.81,29.81,0,0,0,2.62,2.36,31.61,31.61,0,0,0,2.9,2l.93.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.82,204.85s0-.14,0-.39,0-.72-.05-1.08c0-.91-.14-2.16-.32-3.53s-.43-2.61-.63-3.49l-.24-1.05c-.06-.25-.08-.39-.08-.39s0,.13.12.38.17.6.28,1c.21.88.46,2.12.65,3.5a34.18,34.18,0,0,1,.29,3.54c0,.45,0,.82,0,1.08S510.82,204.85,510.82,204.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.27,198a1.19,1.19,0,0,1,0,.33c0,.31-.06.6-.08.88-.09.75-.24,1.78-.47,2.9s-.5,2.13-.72,2.85c-.09.27-.18.55-.27.85s-.12.3-.12.3a1.6,1.6,0,0,1,.08-.32c.08-.29.16-.58.24-.85.2-.72.46-1.73.69-2.85s.39-2.14.5-2.89c0-.28.07-.57.11-.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.75,206.27a12.48,12.48,0,0,1,.29-1.63,11.06,11.06,0,0,1,.39-1.61,15.37,15.37,0,0,1-.29,1.63A12.88,12.88,0,0,1,531.75,206.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.77,210.92s0-.25.08-.67.08-1,.09-1.64c0-.44,0-.92,0-1.64v-.5a.54.54,0,0,1,0-.18,4.55,4.55,0,0,1,.06.68c0,.42,0,1,0,1.65a13.3,13.3,0,0,1-.13,1.64A3.46,3.46,0,0,1,545.77,210.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.46,214.18c-1.08-4.35-5.55-7.15-10-7.85s-8.94.21-13.39.78-9.2.71-13.19-1.36a15.46,15.46,0,0,0-1.85,7.65l2.34,0c.49,3.38,3.58,6,6.91,6.69s5.53.75,8.65-.61c3.28-1.44,7.53-3.61,10.75-4.74s6.78-1.69,10-.63",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.21,206.79a7.17,7.17,0,0,1-.4.94A19,19,0,0,0,513,210a15.48,15.48,0,0,0-.49,2.4,7.3,7.3,0,0,1-.11,1,3.55,3.55,0,0,1,0-1,11.12,11.12,0,0,1,.43-2.44,12.88,12.88,0,0,1,.89-2.31A3.64,3.64,0,0,1,514.21,206.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.56,211.5a6,6,0,0,1-1.23-.11,6.49,6.49,0,0,1-1.24-.16,2.83,2.83,0,0,1,1.26,0A2.87,2.87,0,0,1,512.56,211.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.06,208.8s-.46-.28-1.07-.5-1.14-.23-1.14-.29a2.36,2.36,0,0,1,2.21.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.71,207.37h.7c.45,0,1.12,0,2,0a40.06,40.06,0,0,0,7.3-.75,31,31,0,0,1,11-.3,14.78,14.78,0,0,1,6.06,2.43,11.13,11.13,0,0,1,4.16,5.65l.06.22-.21-.1a8.4,8.4,0,0,0-3-.82,19,19,0,0,0-7.42,1.33,63.79,63.79,0,0,0-6.57,2.67c-1,.48-2,1-3,1.38a18,18,0,0,1-2.94,1.07,14.68,14.68,0,0,1-5.6.22,10.52,10.52,0,0,1-4.31-1.63,8.42,8.42,0,0,1-2.41-2.52,8.12,8.12,0,0,1-.89-2c-.13-.49-.17-.75-.17-.75a9.78,9.78,0,0,0,1.13,2.73,8.3,8.3,0,0,0,2.41,2.46,10.32,10.32,0,0,0,4.27,1.59,14.55,14.55,0,0,0,5.53-.25,16.58,16.58,0,0,0,2.91-1.07c1-.43,2-.9,3-1.38a63.28,63.28,0,0,1,6.59-2.7,19.47,19.47,0,0,1,7.5-1.34,8.79,8.79,0,0,1,3.1.84l-.14.12a10.92,10.92,0,0,0-4.08-5.54,14.72,14.72,0,0,0-6-2.41,31.24,31.24,0,0,0-10.91.26,37.38,37.38,0,0,1-7.32.68C518.66,207.44,517.71,207.37,517.71,207.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.55,219.54a3.17,3.17,0,0,1-.17-.46,12.08,12.08,0,0,1-.34-1.28,16.07,16.07,0,0,1,.61-8.65,12.33,12.33,0,0,1,.51-1.22,2,2,0,0,1,.24-.43s-.27.65-.61,1.7a17.88,17.88,0,0,0-.84,4.25,18.08,18.08,0,0,0,.24,4.32C517.38,218.87,517.59,219.53,517.55,219.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.21,213.65a5,5,0,0,1,.16.84c.08.52.23,1.23.43,2,.41,1.55.81,2.8.75,2.82a3.32,3.32,0,0,1-.33-.79c-.18-.5-.42-1.19-.62-2a12.77,12.77,0,0,1-.38-2A2.65,2.65,0,0,1,526.21,213.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525,210.26a14.86,14.86,0,0,1,.11,1.63c.07.89.22,1.6.16,1.62a6,6,0,0,1-.27-3.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.12,206.77c.06,0-.21.67-.36,1.5s-.14,1.53-.2,1.53a3.2,3.2,0,0,1,0-1.57A3.12,3.12,0,0,1,527.12,206.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534,208.71a2.75,2.75,0,0,1-.61-2.52c.07,0,0,.6.19,1.29S534.08,208.68,534,208.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.4,214.33a4.11,4.11,0,0,1-.57-.79,14.06,14.06,0,0,1-1.09-2.09,15.54,15.54,0,0,1-.76-2.23,4.35,4.35,0,0,1-.17-1,5.75,5.75,0,0,1,.31.92c.18.57.45,1.35.81,2.19s.73,1.57,1,2.1A4.82,4.82,0,0,1,539.4,214.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.9,207.07c0,.05-.14.22-.31.45s-.27.44-.33.42,0-.28.16-.55S540.87,207,540.9,207.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.81,214.52a3.33,3.33,0,0,1-.29-.25,8.1,8.1,0,0,0-4.65-2,13.82,13.82,0,0,0-5.9.64,65.86,65.86,0,0,0-6.79,2.8,21.83,21.83,0,0,1-7,2,17.14,17.14,0,0,1-6-.52,16.73,16.73,0,0,1-3.76-1.49c-.42-.23-.73-.43-.94-.57l-.32-.21.33.2c.21.13.53.32.95.54a17.52,17.52,0,0,0,9.7,2,22.06,22.06,0,0,0,7-2,63,63,0,0,1,6.8-2.8,13.83,13.83,0,0,1,5.94-.63,9.22,9.22,0,0,1,3.79,1.38A6.23,6.23,0,0,1,548.81,214.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.13,209.81s-.25.12-.71.31-1.12.45-2,.74a20.58,20.58,0,0,1-6.82,1.13,25.05,25.05,0,0,1-6.82-1.15c-1.7-.49-2.74-.86-2.74-.86l.75.21,2,.58a26,26,0,0,0,6.8,1.12,21.11,21.11,0,0,0,6.8-1.1c.84-.28,1.51-.52,2-.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.28,208.75l-.25-.16a6.34,6.34,0,0,0-.71-.42,9.91,9.91,0,0,0-2.86-1A15.9,15.9,0,0,0,534,207c-1.69.16-3.52.54-5.45.9a29.68,29.68,0,0,1-10,.28c-2.56-.36-4.1-.75-4.1-.75l1.1.2c.7.13,1.73.31,3,.47a29.9,29.9,0,0,0,10-.3c1.93-.36,3.77-.74,5.47-.9a15.26,15.26,0,0,1,4.51.17,9.42,9.42,0,0,1,2.86,1A7,7,0,0,1,542.28,208.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.58,214a17.38,17.38,0,0,0-2.75-3,11.38,11.38,0,0,0-3.85-2.06,11.55,11.55,0,0,0-5.31-.34,14.75,14.75,0,0,0-5,2c-1.44.84-2.74,1.66-3.91,2.21a10.57,10.57,0,0,1-2.89,1,5,5,0,0,1-.82.08c-.19,0-.29,0-.29,0a14.7,14.7,0,0,0,3.84-1.35c1.12-.58,2.38-1.42,3.83-2.29a14.47,14.47,0,0,1,5.13-2.1,11.47,11.47,0,0,1,9.49,2.62,11.41,11.41,0,0,1,2,2.3A3.72,3.72,0,0,1,548.58,214Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.69,208.9a16.7,16.7,0,0,1-6.1,1.36,16.51,16.51,0,0,1-6.23-.48c0-.15,2.79.21,6.19,0S534.65,208.75,534.69,208.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.74,205.83l-1.12-.48c-.75-.31-1.84-.76-3.27-1.28a41.4,41.4,0,0,0-12.58-2.61A27.2,27.2,0,0,0,504,202.6a21,21,0,0,0-8.73,5.11c-2.6,2.49-4.78,5.64-7.77,8.21a13,13,0,0,1-5.26,2.79,11.43,11.43,0,0,1-6.1-.36,16.8,16.8,0,0,1-5.36-3,26.36,26.36,0,0,1-4.11-4.35c-2.4-3.11-4.31-6.39-6.5-9.26a46,46,0,0,0-6.92-7.49,28.18,28.18,0,0,0-7.54-4.67,21.18,21.18,0,0,0-12.63-1.26,17.27,17.27,0,0,0-3.32,1.11l-1.1.55,1.09-.57a17,17,0,0,1,3.32-1.13,21.26,21.26,0,0,1,12.67,1.23,27.91,27.91,0,0,1,7.56,4.68,45,45,0,0,1,7,7.5c2.19,2.86,4.1,6.15,6.5,9.25a26.53,26.53,0,0,0,4.09,4.33,16.57,16.57,0,0,0,5.34,3,11.31,11.31,0,0,0,6,.36,12.87,12.87,0,0,0,5.21-2.77c3-2.55,5.16-5.7,7.78-8.2a21,21,0,0,1,8.76-5.12,27.08,27.08,0,0,1,8.82-1.13A41.21,41.21,0,0,1,525.36,204C528.22,205.09,529.74,205.83,529.74,205.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.67,208.75a6.32,6.32,0,0,1-1.58-.06,9.83,9.83,0,0,1-4-1.64,18.29,18.29,0,0,1-4.43-4.6,75.78,75.78,0,0,0-4.64-6.3,38.69,38.69,0,0,0-11.06-8.8,40.13,40.13,0,0,0-3.92-1.8L449.6,185s.54.17,1.5.52a37.85,37.85,0,0,1,3.93,1.78,38.23,38.23,0,0,1,11.11,8.79,74.67,74.67,0,0,1,4.64,6.31,18.37,18.37,0,0,0,4.39,4.6,9.92,9.92,0,0,0,3.93,1.66,9,9,0,0,0,1.16.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.71,200.3a3.48,3.48,0,0,1-.31-.17c-.19-.11-.48-.29-.86-.49a28.74,28.74,0,0,0-3.31-1.58,29,29,0,0,0-23.5.73,29.07,29.07,0,0,0-3.2,1.78c-.37.23-.64.43-.84.55l-.29.19s.38-.29,1.1-.77a28.39,28.39,0,0,1,3.2-1.81,28.7,28.7,0,0,1,23.56-.74,27,27,0,0,1,3.3,1.61C526.31,200,526.71,200.3,526.71,200.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.38,204.76s-.05-.14-.12-.4-.19-.62-.33-1.07a27.92,27.92,0,0,0-1.41-3.42,25.9,25.9,0,0,0-1.89-3.18c-.27-.39-.49-.7-.65-.91s-.24-.33-.24-.33a13.14,13.14,0,0,1,.95,1.2,23.35,23.35,0,0,1,3.31,6.62A13.34,13.34,0,0,1,506.38,204.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517,195.47s.06.55.08,1.46a23,23,0,0,1-.24,3.51,23.27,23.27,0,0,1-.76,3.44c-.27.86-.49,1.37-.49,1.37s0-.13.11-.37.21-.69.31-1a29,29,0,0,0,.73-3.44,26,26,0,0,0,.26-3.49c0-.36,0-.71,0-1.07S517,195.47,517,195.47Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494,212.43a12.58,12.58,0,0,1-1.17-.74,19.86,19.86,0,0,1-2.55-2.16A19.35,19.35,0,0,1,488.1,207a13.4,13.4,0,0,1-.74-1.18s.09.11.22.31.33.48.58.83a21.29,21.29,0,0,0,2.15,2.53,22,22,0,0,0,2.52,2.18l.83.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.53,209.32a7.67,7.67,0,0,1-.24-1,11.66,11.66,0,0,1-.13-2.57,11.4,11.4,0,0,1,.44-2.54,7.39,7.39,0,0,1,.37-1,2.61,2.61,0,0,1-.08.28c-.06.17-.13.42-.22.74a13,13,0,0,0-.41,2.53,13.2,13.2,0,0,0,.1,2.55c.05.33.09.59.13.77A1.44,1.44,0,0,1,478.53,209.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.48,222.28a16.35,16.35,0,0,1-.74-1.62,25.16,25.16,0,0,1-1.23-4.13,23.62,23.62,0,0,1-.46-4.28,17.67,17.67,0,0,1,.06-1.78V211c0,.3,0,.75,0,1.3a27.15,27.15,0,0,0,.5,4.26,25.71,25.71,0,0,0,1.19,4.12c.2.51.37.92.49,1.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.23,201.45a7.92,7.92,0,0,0,.18.78c.16.41.4.69.37.71a1.41,1.41,0,0,1-.46-.68A1.34,1.34,0,0,1,490.23,201.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.71,197.71l-.65.36c-.42.22-1,.56-1.75,1a35.55,35.55,0,0,0-9.85,8.87c-.51.68-.91,1.25-1.17,1.64s-.43.61-.43.61a26.11,26.11,0,0,1,1.55-2.29,33.6,33.6,0,0,1,9.86-8.89A26.15,26.15,0,0,1,470.71,197.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.68,187.68l-.62.15c-.41.09-1,.24-1.7.43a36.41,36.41,0,0,0-5.42,2,35.38,35.38,0,0,0-5,2.83c-.61.42-1.1.77-1.43,1l-.52.37s.69-.6,1.91-1.45a33.48,33.48,0,0,1,5-2.87,35,35,0,0,1,5.45-2C457.77,187.82,458.68,187.68,458.68,187.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.29,205.3a2.44,2.44,0,0,1-.1.62,1.76,1.76,0,0,1-.2.59,2,2,0,0,1,.1-.62A1.76,1.76,0,0,1,540.29,205.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.7,204.85s4.52.94,6.44,1.36c.63.14,1.27,0,1.9.15a23.29,23.29,0,0,0,8.35-.15c1.91-.7,2,1.74-.07,2.79a10.47,10.47,0,0,1-3.33,1.17l5,4a1.34,1.34,0,0,1,.48.83l1.27,8.8a1.51,1.51,0,0,1-1,1.74.74.74,0,0,1-1-.34l.14,1.18a1.55,1.55,0,0,1-3.06.52.22.22,0,0,1,0-.08l-1.75,1s-1.16,1.2-2.41-.47c-1-1.38-4.13-6.86-4.13-6.86s-13.18-5.55-13-7.77Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.86,226.89a13.7,13.7,0,0,1-.36-2.13c-.2-1.3-.58-3.13-.84-5.13-.18-1-.41-1.95-.63-2.74a1.59,1.59,0,0,0-.71-.82l-.92-.58a9.34,9.34,0,0,1-1.76-1.26,8.32,8.32,0,0,1,2,.94l.95.53a2,2,0,0,1,.94,1,23.93,23.93,0,0,1,.69,2.83c.27,2,.58,3.83.7,5.17A7.17,7.17,0,0,1,600.86,226.89Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.78,225.19c-.21,0-.54-3.16-1.35-7a6.09,6.09,0,0,0-.84-2.48,15.58,15.58,0,0,0-1.62-1.52,8.65,8.65,0,0,0-1.22-.86c-.31-.17-.5-.21-.5-.25s.22-.06.58.06a5.73,5.73,0,0,1,1.36.76,12.11,12.11,0,0,1,1.75,1.49,5.9,5.9,0,0,1,1,2.69,38.12,38.12,0,0,1,.75,5A10,10,0,0,1,603.78,225.19Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593,216.86a6.46,6.46,0,0,1,1.72.81l.84.46a2.94,2.94,0,0,1,1,.7,2.84,2.84,0,0,1,.56,1.16c.12.41.25.83.39,1.25a40.94,40.94,0,0,1,1.65,6.28,40.57,40.57,0,0,1-2.15-6.11l-.37-1.25a2.57,2.57,0,0,0-.45-1,2.64,2.64,0,0,0-.8-.62l-.8-.52A6.8,6.8,0,0,1,593,216.86Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.35,207.35c.06-.2,1.93.53,4,1.74s3.63,2.47,3.52,2.6-1.69-1-3.78-2.15L594.44,208A5.65,5.65,0,0,1,593.35,207.35Z",
    style: {
      fill: "#eb996e"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrial);
export default __webpack_public_path__ + "static/media/trial.1da5899f3b548a901acc9fe21f6f6392.svg";
export { ForwardRef as ReactComponent };